// LDF: Standardansichten der Listen (Kunden, ohne Sperren und Privatkunden). Eigene Datei, damit keine Import-Kreise entstehen.
export const CONTACT_FILTER_DEFAULTS = { company_contact_blocked: false, company_private: false, had_contact: true };
export const COMPANY_FILTER_DEFAULTS = { hidden: false, contact_blocked: false, is_private: false, is_customer: true };
